/* eslint-disable max-len */
/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable security/detect-object-injection */
import React, { useEffect, useState } from 'react'
import { baseURL, CDN } from '../../constants';
import moment from 'moment'
import RelatedDocuments from './RelatedDocuments';
import { CamelCase } from '../../redux/helper/CamelCase';
export default function DistributorComments({ OrderData }) {
    const [reject, setReject] = useState(false);
    const findRoleName = (role, approver) => {
        debugger
        const itemRrole = approver.find((item) => item?.approver === role);
        return itemRrole ? itemRrole.role_name : false;
    };
    useEffect(() => {
        setReject(findRoleName(OrderData?.order?.order_cancelled_by?.role, OrderData?.order?.approvals?.approval));
    }, [OrderData]);
    const handleSort = (a,b) =>{
        (a,b)=> moment.unix(OrderData?.order?.approvals[a].created_at).format("MM/DD/YYYY")-moment.unix(OrderData?.order?.approvals[b].created_at).format("MM/DD/YYYY")
    }
    return (
        <>
            {OrderData.order.status !=="0"
                ? <>
                    <div className="border border-[#CBC7C7 rounded-md bg-[#F5F5FA] h-auto p-3 my-4">
                        <p className="font-semibold text-base text-[#090406]">Distributor Comments</p>
                        <p className="my-2 font-normal text-sm text-[#555259] text-justify">{OrderData?.order?.instruction}</p>
                        <>
                            {OrderData && OrderData.order?.po_document.length > 0 && OrderData.order?.po_document?.map((item,i) => (
                                <div className="flex items-center flex-wrap" key={i}>
                                    <img src="/images/doc.svg" alt="icon" />
                                    <p className="font-semibold text-sm text-[#000000] ml-1.5">{item?.split('/')?.at(-1)}</p>

                                    <div  
                                        onClick={() => {
                                            window.open(`${CDN}/${item}`, '_blank');
                                        }} className="flex items-center ml-4">
                                        <img src="/images/download.svg" alt="icon" className="cursor-pointer" />
                                        <p
                                            className="text-[#5B5B5B] text-xs3 font-semibold ml-1 cursor-pointer"
                                        >
                                            Download

                                        </p>
                                    </div>
                                </div>
                            ))}
                        </>
                        <p className="text-[#090406] font-semibold text-base mt-3">Ador Comments</p>
                        { OrderData.order?.approvals.approval.map((item, index) => (
                            <p key = {index} className="font-normal text-sm text-[#555259]">
                                <b>{item.role_name}</b>
                                {' '}
                                -
                                {' '}
                                {item?.role_name === reject && item?.note === '' ? 'Cancelled' : item.note}
                                <br />
                                {item?.role_name === reject
                        && <span>{`${OrderData?.order?.order_cancelled_by?.employee_code} - ${OrderData?.order?.order_cancelled_by?.first_name} ${OrderData?.order?.order_cancelled_by?.last_name}`}</span>}
                            </p>
                        ))}
                    </div>
                    <RelatedDocuments OrderData={OrderData}/>
                </>:null
            }
        </>
    )
}
